export default __webpack_public_path__ + "static/media/youtube.9efef4d0.svg";